webpackJsonp([51102042152165],{

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _forms = __webpack_require__(36);
	
	var _components = __webpack_require__(3);
	
	var _Paths = __webpack_require__(14);
	
	var Paths = _interopRequireWildcard(_Paths);
	
	var _utils = __webpack_require__(11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgotPasswordPage = function (_React$Component) {
	  _inherits(ForgotPasswordPage, _React$Component);
	
	  function ForgotPasswordPage(props) {
	    _classCallCheck(this, ForgotPasswordPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      success: false
	    };
	    return _this;
	  }
	
	  ForgotPasswordPage.prototype.componentDidMount = function componentDidMount() {
	    (0, _utils.seoPageChange)();
	  };
	
	  ForgotPasswordPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var success = this.state.success;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'LoginPage grid-row grid-column v-align h-align full-height' },
	      _react2.default.createElement(_components.StripeBG, null),
	      _react2.default.createElement(
	        _components.PageAnimator,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'form form-page' },
	          _react2.default.createElement(
	            'div',
	            { className: 'f1 t-center f-strong f-subdued s8' },
	            'Password Reset'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'login-form s6' },
	            !success ? _react2.default.createElement(_forms.ForgotPasswordForm, { onSuccess: function onSuccess(model) {
	                return _this2.setState({ success: true });
	              } }) : _react2.default.createElement(
	              'div',
	              { className: 'pt-callout pt-intent-primary' },
	              'We\'ve sent you an email to reset your password. Please check your inbox.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 's1' },
	            _react2.default.createElement(
	              _components.Link,
	              { href: Paths.LOGIN, className: 'f4' },
	              _react2.default.createElement('span', { className: 'pt-icon-standard pt-icon-arrow-left' }),
	              'Back to login'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ForgotPasswordPage;
	}(_react2.default.Component);
	
	exports.default = ForgotPasswordPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-account-forgotpassword-js-70f183a0b80b76abfddf.js